import { Flex, theme } from "antd";
import { useState } from "react";
import { useParams } from "react-router";
import { useAuthContext } from "../contexts/auth/useAuthContext";
import GlobalLoader from "./GlobalLoader";

export const ChartPage = () => {
  const { token } = theme.useToken();
  const { authToken } = useAuthContext();
  const params = useParams();

  const [isIframeLoading, setIsIframeLoading] = useState(true);

  const iframeParameters: {
    a: string | null;
    chartId?: string;
  } = {
    a: authToken,
    chartId: params?.chartId,
  };

  const iframeSrc = `${
    import.meta.env.ADMIN_ADD_IN_URL
  }content/web.html?${Object.entries(iframeParameters)
    .map(([key, value]) => (value ? `${key}=${value}` : ""))
    .filter(Boolean)
    .join("&")}`;

  return (
    <Flex vertical gap={token.marginLG} style={
      {position: "relative", width: "100%", height: "100%", overflow: "hidden"}
    }>
      {isIframeLoading && <GlobalLoader position="absolute" />}
      <iframe
        src={iframeSrc}
        width="100%"
        height="700px"
        title="Chart"
        allow="clipboard-write"
        onLoad={() => setIsIframeLoading(false)}
        style={{
          display: isIframeLoading ? "none" : "block",
          border: "none",
          boxShadow: `0 0 0 1px ${token.colorBorderSecondary}`,
          borderRadius: token.borderRadiusLG,
        }}
      />
    </Flex>
  );
};
